import React from 'react'
import './CommandControlContent.scss'
import CallToActionBanner from '../../CallToActionBanner/CallToActionBanner'
import { Link } from '@reach/router'
import { FaBolt, FaBullseye, FaHandshake, FaChartBar } from 'react-icons/fa'

export class CommandControlContent extends React.Component {
  render() {
    return (
      <div className="command-control-content">
        <div className="split light subheader-block">
          <div className="text-wrap">
            Rackner's Command and Control capabilities center on human-machine
            teaming that accelerates the OODA loop while maintaining human control - demonstrated
            operationally at the U.S. Air Force Shadow Operations Center with
            validated results from battle managers.
          </div>
        </div>

        <section className="padding-large">
          <h2>Operational AI for Battle Management</h2>
          <div className="row">
            <div className="col-md-12">
              <p className="centered-text">
                Through the DASH (Decision Advantage Sprint for Human-Machine-Teaming)
                events at the Shadow Operations Center, Rackner demonstrated
                AI-enabled C2 capabilities with operational Air Force battle managers
                from units including the 729th Air Control Squadron, achieving
                Technology Readiness Level 7 with quantified performance improvements.
              </p>
            </div>
          </div>
        </section>

        <div className="split pattern">
          <h2>Core C2 Capabilities</h2>
          <div className="row c2-capabilities">
            <div className="col-md-6">
              <div className="capability-box">
                <div className="icon"><FaBolt /></div>
                <div className="title">Real-Time Data Integration</div>
                <div className="description">
                  Seamless integration with tactical data links (Link-16, JREAP-C),
                  radar tracks (MSCT), and communications systems for comprehensive
                  situational awareness.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-box">
                <div className="icon"><FaBullseye /></div>
                <div className="title">Entity Assessment & Prioritization</div>
                <div className="description">
                  Automated processing of multiple data streams to identify
                  actionable entities and generate prioritized battle recommendations.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-box">
                <div className="icon"><FaHandshake /></div>
                <div className="title">Human-Machine Teaming</div>
                <div className="description">
                  Augments operator capabilities without replacing human judgment - operators
                  retain full control of all decision-making authority.
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="capability-box">
                <div className="icon"><FaChartBar /></div>
                <div className="title">Explainable AI</div>
                <div className="description">
                  Transparent AI reasoning allows operators to understand and validate
                  recommendations before taking action, maintaining trust and control.
                </div>
              </div>
            </div>
          </div>
        </div>

        <section className="padding-large light">
          <h2>Supporting JADC2 & Service Integration</h2>
          <div className="integration-blocks">
            <div className="integration-item">
              <h3>Air Force Transformation</h3>
              <p>
                Direct support for the Air Force's Transformational Model for Battle
                Management and Joint All-Domain Command and Control (JADC2) initiative.
              </p>
            </div>
            <div className="integration-item">
              <h3>Navy Systems</h3>
              <p>
                Integration pathways identified with Project Overmatch, AEGIS combat
                systems, Naval Integrated Fire Control-Counter Air (NIFC-CA), and
                Common Control System for unmanned platforms.
              </p>
            </div>
            <div className="integration-item">
              <h3>Multi-Domain Operations</h3>
              <p>
                Modular microservices architecture enables rapid adaptation to
                service-specific use cases from carrier strike group air defense to
                distributed maritime operations.
              </p>
            </div>
          </div>
        </section>

        <div className="split">
          <h2>REAPER Platform</h2>
          <div className="reaper-highlight">
            <p>
              Rackner's REAPER (Rapid Entity Assessment and Prioritization for
              Effector Response) platform is the cornerstone of our C2 capabilities,
              delivering proven results:
            </p>
            <div className="row results-row">
              <div className="col-md-4">
                <div className="result-card">
                  <div className="metric">TRL 7</div>
                  <div className="description">
                    Operational demonstration at AF Shadow Ops Center
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="result-card">
                  <div className="metric">561</div>
                  <div className="description">
                    Autonomous battle courses of action generated
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="result-card">
                  <div className="metric">2x Faster</div>
                  <div className="description">
                    Operator decision speed vs. manual processes
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="button-wrap">
            <Link to="/reaper">
              <button className="btn-raised-light-blue-inverse big">
                Explore REAPER Platform
              </button>
            </Link>
          </div>
        </div>

        <CallToActionBanner route={'contact'} linkText={'Learn More'} />
      </div>
    )
  }
}

export default CommandControlContent
